import React from 'react';

export const useDebounce = (callback: () => unknown, debounceTime = 500) => {
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    timerRef.current = setTimeout(() => {
      callback();
    }, debounceTime);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [callback, debounceTime]);
};
